import { render, staticRenderFns } from "./solutionDetail.vue?vue&type=template&id=1250064a&scoped=true"
import script from "./solutionDetail.vue?vue&type=script&lang=js"
export * from "./solutionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1250064a",
  null
  
)

export default component.exports